<template>
  <div id="dataV">
    <div class="dataV_Border">
      <div class="first" v-if="roleType !== 6">
        <p>报名审核缴费数据大屏</p>
        <img :src="dataV_A" alt="">
        <el-button type="primary" round style="margin: 24px auto; display: block;" @click="importDialog = true">查看大屏</el-button>
      </div>    
      <div class="second">
        <p>考试数据大屏</p>
        <img :src="dataV_B" alt="">
        <el-button type="primary" round style="margin: 24px auto; display: block;" @click="importBDialog = true">查看大屏</el-button>
      </div>
      <div class="second" v-if="roleType == 6">

      </div>
      <div class="second" v-if="roleType == 6">

      </div>
      <div class="third" v-if="roleType !== 6">
        <p>评阅数据大屏</p>
        <img :src="dataV_C" alt="">
        <el-button type="primary" round style="margin: 24px auto; display: block;" @click="importCDialog = true" >查看大屏</el-button>
      </div>
    </div>

    <!-- 报名大屏 -->
    <ots-custom-dialog
      :dialog.sync="importDialog"
      title="请选择要查看的考试批次"
      width="50%"
      :showClose='false'
    >
      <template v-slot:content>
          <el-select v-model="value" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.planId"
              :label="item.planName"
              :value="item.planId">
            </el-option>
          </el-select>
      </template>
      <template v-slot:footer>
        <el-button round @click="importDialog = false">取消</el-button>
        <el-button round type="primary" @click="goDataV_A">确定</el-button>
      </template>
    </ots-custom-dialog>

    <!-- 考中大屏 -->
    <el-dialog
      title="请选择要查看的考试批次与对应场次"
      :visible.sync="importBDialog"
      :show-close="false"
    >

      <el-select v-model="sessionId" placeholder="请选择批次 & 场次" @change="changeSession">
        <el-option
          v-for="item in sessionOptions"
          :key="item.sessionId"
          :label="item.optionText"
          :value="item.sessionId">
        </el-option>
      </el-select>

      <span slot="footer" class="dialog-footer">
        <el-button round @click="importBDialog = false">取消</el-button>
        <el-button round type="primary" @click="goDataV_B">确定</el-button>
      </span>

    </el-dialog>

    <!-- 评阅大屏 -->
    <ots-custom-dialog
      :dialog.sync="importCDialog"
      title="请选择要查看的考试批次"
      width="50%"
      :showClose='false'
    >
      <template v-slot:content>
          <el-select v-model="ReviewPlanId" placeholder="请选择批次" style="margin-right: 16px;">
            <el-option
              v-for="item in ReviewOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
          <el-select v-model="courseId" placeholder="请选择批次">
            <el-option
              v-for="item in courseList"
              :key="item.courseId"
              :label="item.courseName"
              :value="item.courseId">
            </el-option>
          </el-select>
      </template>
      <template v-slot:footer>
        <el-button round @click="importCDialog = false">取消</el-button>
        <el-button round type="primary" @click="goDataV_C">确定</el-button>
      </template>
    </ots-custom-dialog>

  </div>
</template>
<script>
import { getScreenPlanListApi, querySessionAvailableApi, getSelectPlanApi, getPlanReviewCourseApi } from '@/http/modules/dataV.js'
export default {

  data() {
    return {
      // 报名
      dataV_A: require("@/assets/img/dataV_A.png"),
      importDialog: false,
      value: '',
      options: [],

      // 考试
      dataV_B: require("@/assets/img/dataV_B.png"),
      importBDialog: false,
      planId: '',
      sessionId: '',
      sessionOptions: [],

      // 评阅
      dataV_C: require("@/assets/img/dataV_C.png"),
      importCDialog: false,
      ReviewPlanId: '',
      ReviewOptions: [],

      // 评阅 => 课程
      courseList: [],
      courseId: '',
      courseName: '',
      planInfo: {},

      // 登录用户权限
      roleType: '',
    }
  },
  // 

  watch: {
    'ReviewPlanId': 'getCourseList',
    'courseId': 'setCourseName'
  },

  created() {
    this.initData()
    // 巡考教师(roleType == 6) 只看考中大屏
    let userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
    this.roleType = userInfo.roleType

  },

  methods: {
    /**
     * @param { 报名大屏 批次 }
     */   
    async initData() {
      let { data } = await getScreenPlanListApi()
      if (data.length > 0) {
        this.options = data
        this.value = data[0].planId
      } else {
        this.value = ''
        this.options = []
      }

      let list = await querySessionAvailableApi()
      if (list.data.length > 0) {
        this.planId = list.data[0].planId
        this.sessionId = list.data[0].sessionId
        this.sessionOptions = list.data
      } else {
        this.planId = ''
        this.sessionId = ''
        this.sessionOptions = []
      }

      let res = await getSelectPlanApi({needAudit: 10})
      if (res.data.length > 0) {
        this.ReviewPlanId = res.data[0].id
        this.ReviewOptions = res.data
      } else {
        this.ReviewPlanId = ''
        this.ReviewOptions = []
      }

    },

    /**
     * @param { 考中大屏 批次 + 场次 }
     */  
    changeSession(item) {
      this.sessionOptions.map(e=>{
        if (e.sessionId == item) {
          this.planId = e.planId
          this.sessionId = e.sessionId
        }
      })
    },

    /**
     * @param { 报名大屏 + F11 }
     */
    goDataV_A(){
      let that = this
      if (this.$fullscreen.isFullscreen) {
        this.$fullscreen.exit()
      } else {
        this.$fullscreen.request()
      }
      clearTimeout(timer)
      let timer = setTimeout(() => {
        that.$router.push({path: `/dataV_A?planId=${that.value}` })
      }, 500)
    },

    /**
     * @param { 考中大屏 + F11 }
     */
    goDataV_B() {
      let that = this

      // 测试: 之后删除
      // this.planId = '';
      // this.sessionId = '';

      if (this.planId && this.sessionId) {
        if (this.$fullscreen.isFullscreen) {
          this.$fullscreen.exit()
        } else {
          this.$fullscreen.request()
        }

        clearTimeout(timer)
        let timer = setTimeout(() => {
          that.$router.push({path:'/dataV_B', query: {planId: this.planId, sessionId: this.sessionId}})
        }, 500)

      } else {
        this.$message.warning('当前批次无可查看的考试大屏！')
      }

    },

    /**
     * @param { 评阅大屏 + F11 }
     */
    goDataV_C() {
      let that = this
      if (this.ReviewPlanId) {
        if (this.$fullscreen.isFullscreen) {
          this.$fullscreen.exit()
        } else {
          this.$fullscreen.request()
        }
        clearTimeout(timer)
        let timer = setTimeout(() => {
          that.$router.push({path:'/dataV_C', query: { planId: that.ReviewPlanId, courseId: that.courseId, planName: that.planInfo.name, courseName: that.courseName }})
        }, 500)
      } else {
        this.$message.warning('当前暂无可查看的评阅大屏！')
      }
    },

    /**
     * @param { 评阅大屏 => 所选批次信息 }
     */
    getCourseList(planId) {
      this.ReviewOptions.map(e=>{
        if (e.id == planId) {
          this.planInfo = e
        }
      })

      getPlanReviewCourseApi({ planId }).then(res=>{
        if (res.code == 1) {
          this.courseId = ''
          this.courseList = [ { courseId: '', courseName: '全部' } , ...res.data ]
        }
      })
    },

    /**
     * @param { 获取选中课程名 }
     */
    setCourseName(courseId) {
      this.courseList.map(e=>{
        if (e.courseId == courseId) {
          this.courseName = e.courseName
        }
      })
    },

  }
  
}
</script>

<style lang="less" scoped>
.dataV_Border {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-around;

  &>div {
    height: auto;
    width: 30%;
    &>img {
      width: 100%;
      border: 1px dashed #006AFF;
      border-radius: 8px;
    }
    &>p {
      text-align: center;
      font-size: 24px;
      margin-bottom: 16px;
    }
  }

}

// Dialog
/deep/ .el-dialog__wrapper .el-dialog {
  width: 620px;
  border-radius: 8px;
  .el-dialog__body {
    .el-select {
      width: 580px;
      .el-input.el-input--suffix {
        width: 100%;
      }
      .el-input__inner {
        width: 100%;
      }
    }
  }

  .dialog-footer {
    .el-button {
      width: auto;
      height: 30px;
      border-radius: 15px;
      padding: 0 23px;
      box-sizing: border-box;
    }
  }
}

.dataB_B_select {
  display: flex; 
  width: 100%; 
  flex-wrap: wrap; 
  justify-content: space-around;
  .el-button {
    width: 280px;
    margin: 0;
    margin-bottom: 8px;
  }
}

</style>
